import {
    faExclamationTriangle,
    faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import {
    ListarDocumentoTemplatePorClassificacaoController,
    PreencherTemplateEmailClienteController,
} from "../../../../../Controllers/Geral/Documentos/DocumentosController";
import { EnviarEmailAnexoController } from "../../../../../Controllers/Geral/Email/EmailController";
import { ListarEmailContaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import { ListarUsuariosController } from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import UnForm from "../../../../Form";
import { FroalaEditor } from "../../../Forms/Editor/FroalaEditor";
import { useUserInfor } from "../../../../../Context/User";
import CreatableSelect from "react-select/creatable";
import { ListarContatosController } from "../../../../../Controllers/Geral/Contatos/ContatosController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface htmlQuill {
    editorHtml: string;
}

interface IAgendamentoPeloCliente {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function AgendamentoPeloCliente(props: IAgendamentoPeloCliente) {
    const { id } = useModuloInfo();
    const { ID_CASO, Atendimento } = useAtendimentoPage();
    const FormMethods = useForm();
    const { watch } = FormMethods;
    const watcher = watch();
    const { Config } = useUserInfor();
    const userId = useUserInfor().UserInfor.ID_USUARIO;
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [emailDestinatario, setEmailDestinatario] = useState<
        Array<string> | undefined
    >([]);
    const [remetente, setRemetente] = useState(0);
    const [assunto, setAssunto] = useState(
        Atendimento?.DS_CATEGORIA_ATENDIMENTO
    );

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const { value: LstDocumentoTemplate } = useAsyncEffect(
        () =>
            ListarDocumentoTemplatePorClassificacaoController(id ?? 0, 5, true),
        [id]
    );

    const { value: LstEmailConta } = useAsyncEffect(ListarEmailContaController);

    useEffect(() => {
        if (LstEmailConta && LstEmailConta.length > 0) {
            setRemetente(LstEmailConta[0].ID_EMAIL_CONTA);
        }
    }, [LstEmailConta]);

    const { execute: EnviarEmailAnexo, loading: EnviarEmailLoading } =
        useAsyncCallback(EnviarEmailAnexoController);

    function handleEnviarEmailAgendamentoCliente() {
        onSubmitHandleImage();

        EnviarEmailAnexo({
            DS_ASSUNTO: assunto ?? "",
            DS_MENSAGEM: convertedText.editorHtml,
            ID_EMAIL_CONTA: remetente,
            ID_CASO: ID_CASO,
            DS_DESTINATARIO: emailDestinatario,
        }).then(() => {
            props.setShow(false);
        });
    }

    const [uploading, setUploading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const onSubmitHandleImage = () => {
        if (userId && convertedText && convertedText.editorHtml) {
            // Mapeia o html e substitui o src pelo link que é armazenado no state uploadedImages de forma dinamica
            let modifiedHistoricoHTML = convertedText.editorHtml;
            const imagesToReplace =
                modifiedHistoricoHTML.match(
                    /<img[^>]*src="blob[^"]*"[^>]*>/g
                ) || [];

            imagesToReplace.forEach((imageTag) => {
                const uploadedImageUrl = uploadedImages.shift() || "";
                modifiedHistoricoHTML = modifiedHistoricoHTML.replace(
                    /<img[^>]*src="blob[^"]*"[^>]*>/,
                    imageTag.replace(
                        /src="blob[^"]*"/,
                        `src="${uploadedImageUrl}"`
                    )
                );
            });
            convertedText.editorHtml = modifiedHistoricoHTML;
        }
    };

    const { value: lstContatos } = useAsyncEffect(
        () =>
            ListarContatosController(
                Atendimento?.ID_CONTA ?? 0,
                Atendimento?.ID_CASO
            ),
        []
    );

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
        }),
    };

    const options = lstContatos?.map((contato) => ({
        label: `${contato.DS_EMAIL ? contato.DS_NOME : ""} ${
            contato.DS_EMAIL ? `<${contato.DS_EMAIL}>` : ""
        }`,
        value: contato.DS_EMAIL ?? "",
    }));

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                handleSubmit={handleEnviarEmailAgendamentoCliente}
                usingContext
            >
                {({ getValues, setValue }) => (
                    <>
                        <div className="row m-0">
                            <div className="col-md-12 mb-2">
                                <UnForm.LazySelect
                                    name="ID_USUARIO"
                                    label="Atribuído a"
                                    controller={ListarUsuariosController}
                                    getDS={(ds) => ds.DS_NOME}
                                    getKeyValue={(key) => key.ID_USUARIO}
                                    registerOptions={{
                                        required:
                                            "Insira o técnico responsável",
                                    }}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-md-4 mb-2">
                                <label>Email Remetente:</label>
                                <select
                                    name="ID_REMETENTE"
                                    className="form-control"
                                    value={remetente}
                                    onChange={(e) => {
                                        setRemetente(
                                            Number.parseInt(e.target.value)
                                        );
                                    }}
                                    placeholder={"Digite o email"}
                                    required={true}
                                >
                                    {LstEmailConta &&
                                        LstEmailConta.map((email) => {
                                            return (
                                                <option
                                                    key={email.ID_EMAIL_CONTA}
                                                    value={email.ID_EMAIL_CONTA}
                                                >
                                                    {email.DS_REMETENTE}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                            <div className="col-md-8 mb-2">
                                <label>Email Destinatário:</label>
                                <CreatableSelect
                                    isMulti
                                    isClearable
                                    isSearchable
                                    onChange={(e) => {
                                        setEmailDestinatario(
                                            e.map((value) => value?.value)
                                        );
                                    }}
                                    formatCreateLabel={(value) =>
                                        `Clique para selecionar: ${value}`
                                    }
                                    styles={customStyles}
                                    placeholder={"Digite o email"}
                                    options={options}
                                    defaultValue={
                                        lstContatos?.length === 1
                                            ? {
                                                  value:
                                                      lstContatos[0]
                                                          ?.DS_EMAIL ?? "",
                                                  label: `${
                                                      lstContatos[0]?.DS_NOME ??
                                                      ""
                                                  } <${
                                                      lstContatos[0]
                                                          ?.DS_EMAIL ?? ""
                                                  }>`,
                                              }
                                            : undefined
                                    }
                                    className="Select-menu-outer"
                                />
                            </div>
                        </div>
                        <div className="col-12 mb-2">
                            <label>Template de Email:</label>
                            <UnForm.Select
                                className={`form-control placeholder-dark-50 `}
                                name=""
                                disabled={
                                    watcher.ID_USUARIO === ""
                                        ? true
                                        : watcher.ID_REMETENTE === ""
                                        ? true
                                        : watcher.DS_DESTINATARIO === ""
                                        ? true
                                        : false
                                }
                                onChange={(e) => {
                                    const idTemplateEmail = Number.parseInt(
                                        e.target.value
                                    );
                                    if (e && idTemplateEmail) {
                                        const docTemplate =
                                            LstDocumentoTemplate?.find(
                                                (dt) =>
                                                    dt.ID_DOCUMENTO_TEMPLATE ===
                                                    idTemplateEmail
                                            );
                                        if (
                                            docTemplate &&
                                            docTemplate.DS_ASSUNTO
                                        )
                                            setValue(
                                                "assunto",
                                                docTemplate.DS_ASSUNTO
                                            );
                                        setConvertedText({
                                            editorHtml: "Carregando....",
                                        });
                                        PreencherTemplateEmailClienteController(
                                            idTemplateEmail,
                                            {
                                                ...watcher,
                                                ID_USUARIO: watcher.ID_USUARIO,
                                                ID_CASO: ID_CASO,
                                            }
                                        )
                                            .then((res) => {
                                                setConvertedText({
                                                    editorHtml: res,
                                                });

                                                setAssunto(
                                                    `${docTemplate?.DS_ASSUNTO} - ` +
                                                        `${
                                                            Atendimento?.DS_PRODUTO_COMP?.split(
                                                                "-"
                                                            )[0]
                                                        } - ` +
                                                        `${Atendimento?.DS_PRODUTO}`
                                                );
                                            })
                                            .catch(() => {
                                                setConvertedText({
                                                    editorHtml:
                                                        "Erro ao carregar template.",
                                                });
                                            });
                                    }
                                }}
                            >
                                <option>Modelo de email</option>
                                {LstDocumentoTemplate &&
                                    LstDocumentoTemplate.map((doc) => {
                                        return (
                                            <option
                                                key={doc.ID_DOCUMENTO_TEMPLATE}
                                                value={
                                                    doc.ID_DOCUMENTO_TEMPLATE
                                                }
                                            >
                                                {doc.DS_DOCUMENTO}
                                            </option>
                                        );
                                    })}
                            </UnForm.Select>
                        </div>
                        <div className="col-12 mb-2">
                            <UnForm.Input
                                type="text"
                                name="DS_ASSUNTO"
                                autoComplete="off"
                                label="Assunto"
                                value={assunto}
                                onChange={(e) => {
                                    setAssunto(e.target.value);
                                }}
                                className={`form-control px-0 p-2 placeholder-muted-75`}
                                registerOptions={{
                                    required: "Insira o Assunto do E-mail",
                                }}
                            />
                        </div>
                        <div className="col-md-12 mb-2">
                            <div className=" w-100 h-100">
                                <label>Descrição:</label>
                                <FroalaEditor
                                    onChange={(e) => {
                                        handleChange(e);
                                    }}
                                    value={convertedText.editorHtml || ""}
                                    onImageUploadStart={() =>
                                        setUploading(true)
                                    }
                                    onImageUploadEnd={() => setUploading(false)}
                                    setUploadedImages={setUploadedImages}
                                />
                            </div>
                        </div>

                        {uploading ? (
                            <button
                                type="button"
                                className="btn btn-success font-weight-bold d-flex col-12 justify-content-center"
                                disabled={true}
                            >
                                <div className="row px-4">
                                    <div className="loading-component">
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Carregando...
                                            </span>
                                        </div>
                                    </div>
                                    <div className="ml-2">
                                        {uploading
                                            ? "Carregando imagem"
                                            : "Enviar por email"}
                                    </div>
                                </div>
                            </button>
                        ) : (
                            <>
                                <UnForm.SubmitButton
                                    color="success"
                                    loadingSize="sm"
                                    icon={faPaperPlane}
                                    loading={EnviarEmailLoading}
                                    disabled={
                                        EnviarEmailLoading ||
                                        !Config?.FL_ENVIO_HORARIOS_DISPONIVEIS
                                    }
                                    className="col-12 mt-2"
                                >
                                    Enviar por email
                                </UnForm.SubmitButton>
                                {!Config?.FL_ENVIO_HORARIOS_DISPONIVEIS ? (
                                    <div className="col-12 mt-2">
                                        <div
                                            className="alert alert-custom alert-light-warning fade show mb-5 w-100"
                                            role="alert"
                                        >
                                            <div className="alert-icon text-warning">
                                                <FontAwesomeIcon
                                                    icon={faExclamationTriangle}
                                                    size="2x"
                                                />
                                            </div>
                                            <div className="alert-text">
                                                Para realizar o envio, é
                                                necessário ativar a flag "Envio
                                                de link com horários
                                                disponíveis." nas configurações
                                                gerais do sistema.
                                            </div>
                                            <div className="alert-close">
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">
                                                        <i className="ki ki-close"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        )}
                    </>
                )}
            </UnForm>
        </FormProvider>
    );
}
